import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { Spin, message } from "antd"


import RightImageComponent from './right_image_component'
import AuthFooterComponent from './footer_component'
import AppService from '../../service/app_service';

class SetPasswordPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dashboard: props.dashboard,
      clientId: 'uauth_fc0114271c4e5f18',
      loading: false,
      token: props.match.params.token,
    };
  }


  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });

  }

  setPassword = () => {
    this.setState({ loading: true });

    AppService.setPassword(this.state).then(rec => {
      if (rec) {
        if (rec.code !== "200") {
          message.error(rec.message);
          this.setState({ loading: false });
        } else {
          message.success("Password reset was successful.")
          this.props.history.push("/signin");
        }
      } else {
        message.error("Empty response")
      }
    })
  }

  render() {

    const { loading } = this.state;

    return (
      <div className="page-ath-wrap">
        <div className="page-ath-content">
          <div className="page-ath-header"><a href="/" className="page-ath-logo"><img src="/assets/images/logo.png" srcSet="/assets/images/logo2x.png 2x" alt="logo" /></a></div>

          <Spin spinning={loading}>
            <div className="page-ath-form">
              <h2 className="page-ath-heading">Set New password
              <span>Set your new password based on the password reset made.</span>
              </h2>
              <form action="#" onSubmit={e => e.preventDefault()}>
                <div className="input-item"><input type="password" onChange={this.handleChange}  name="password" placeholder="Your password" className="input-bordered" /></div>
                <div className="d-flex justify-content-between align-items-center">
                  <div><button className="btn btn-primary btn-block" onClick={this.setPassword} >Set Password</button></div>
                  <div><Link to="/signin">Return to login</Link></div>
                </div>
                <div className="gaps-2x" />
              </form>
            </div>
          </Spin>


          <AuthFooterComponent />
        </div>
        <RightImageComponent image="https://static.vecteezy.com/system/resources/previews/002/297/475/original/password-reset-line-icon-vector.jpg" />
      </div>
    );
  }
}

export default withRouter(SetPasswordPage);
